import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "image", "caption", "counter", "thumb"];
  static values = {
    images: Array,
    index: { type: Number, default: 0 },
  };

  connect() {
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    this.unlock();
    window.removeEventListener("keydown", this.onKeydown);
  }

  open(event) {
    event?.stopPropagation?.();
    const index = Number(event.currentTarget.dataset.index || 0);
    this.indexValue = index;
    this.render();
    this.dialogTarget.classList.remove("hidden");
    this.dialogTarget.classList.add("flex");
    this.lock();
    window.addEventListener("keydown", this.onKeydown);
  }

  close(event) {
    event?.stopPropagation?.();
    this.dialogTarget.classList.add("hidden");
    this.dialogTarget.classList.remove("flex");
    this.unlock();
    window.removeEventListener("keydown", this.onKeydown);
  }

  stop(event) {
    event.stopPropagation();
  }

  previous(event) {
    event?.stopPropagation?.();
    const len = this.imagesValue.length;
    this.indexValue = (this.indexValue - 1 + len) % len;
    this.render();
  }

  next(event) {
    event?.stopPropagation?.();
    const len = this.imagesValue.length;
    this.indexValue = (this.indexValue + 1) % len;
    this.render();
  }

  select(event) {
    event?.stopPropagation?.();
    this.indexValue = Number(event.currentTarget.dataset.index);
    this.render();
  }

  key(event) {
    this.onKeydown(event);
  }

  onKeydown(event) {
    if (this.dialogTarget.classList.contains("hidden")) return;
    if (event.key === "Escape") this.close();
    if (event.key === "ArrowLeft") this.previous();
    if (event.key === "ArrowRight") this.next();
  }

  render() {
    const img = this.imagesValue[this.indexValue];
    if (!img) return;

    this.imageTarget.src = img.url;
    this.imageTarget.alt = img.caption || "";
    this.imageTarget.classList.remove("animate-fade-in");
    void this.imageTarget.offsetWidth;
    this.imageTarget.classList.add("animate-fade-in");

    if (this.hasCaptionTarget)
      this.captionTarget.textContent = img.caption || "";
    if (this.hasCounterTarget) {
      const cur = String(this.indexValue + 1).padStart(2, "0");
      const total = String(this.imagesValue.length).padStart(2, "0");
      this.counterTarget.textContent = `${cur} / ${total}`;
    }

    this.thumbTargets.forEach((thumb, i) => {
      const active = i === this.indexValue;
      thumb.classList.toggle("border-accent", active);
      thumb.classList.toggle("border-white/20", !active);
    });
  }

  lock() {
    document.body.style.overflow = "hidden";
  }

  unlock() {
    document.body.style.overflow = "";
  }
}
